// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractCsfList} from "../ContractClient";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractCsfListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractCsfList, setContractCsfList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorDataPointId = useSelector((state) => state.contractDetailListSlc.value.dataPointId);
    const selectorCsfListDrawerState = useSelector((state) => state.contractDetailListSlc.value.csfListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractCsfList = () =>
        getContractCsfList(selectorContractId, selectorDataPointId)

            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractCsfList(data);
            });

    // ****************** END FETCH ****************************

    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractCsfList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.csfListDrawerState)===true]);

// ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractCsfListDrawer() {
        dispatchData(changeContractDetailList({id: 0, csfListDrawerState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MISC ***************************

    const renderContractCsfList = contractCsfList => {
        if (contractCsfList.length <= 0) {
            return "No Data";
        }}

    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractCsfList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {    field: 'sectionOrdinal',
            headerName: 'Section #',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Name',
            description: '',
            sortable: true,
            editable: false,
            width: 500,
        },
        {
            field: 'hierarchy',
            headerName: 'Path',
            description: '',
            sortable: false,
            editable: false,
            width: 200,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: true,
            editable: false,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: true,
            editable: false,
            width: 300,
            hide: false,
        },
        {
            field: 'singleValue',
            headerName: 'Single Value',
            description: '',
            sortable: true,
            editable: false,
            width: 300,
            hide: false,
        },
        {
            field: 'fromValue',
            headerName: 'From Value',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
        {
            field: 'toValue',
            headerName: 'To Value',
            description: '',
            sortable: true,
            editable: false,
            width: 100,
            hide: false,
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1700 },
                }}
                anchor='right'
                open={selectorCsfListDrawerState}
                initialState={{open: false}}
                onClose={closeContractCsfListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractCsfListDrawer()}>Contract Section Filter List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractCsfList"}
                    rows={contractCsfList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractCsfList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractCsfList => contractCsfList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
